export default {
    MUTATE_SEARCH_RESULTS(state, payload) {
        state.searchResults = payload;
    },
    MUTATE_SEARCH_PARAMS(state, payload) {
        state.searchParams = payload.searchTerm;
    }
}